import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-campaign-email-settings',
  templateUrl: './campaign-email-settings.component.html',
  styleUrls: ['./campaign-email-settings.component.scss']
})
export class CampaignEmailSettingsComponent implements OnInit {
  @Input() formGroupCampaign: any = null;


  public footerForEmails:any = null
  public emailPattern = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  public emailPlaceholder = 'New E-Mail...';
  public editorConfig: any = {
    height: 250,
    menubar: false,
    branding: false,
    resize: false,
    fullpage_default_font_family: 'Work Sans, Calibri, sans-serif',
    plugins: [
      'advlist autolink lists link charmap anchor',
      'visualblocks code fullscreen',
      'insertdatetime table paste code help wordcount'
    ],
    toolbar: 'bold italic underline | alignleft aligncenter alignright | linkbutton | fontsizeselect lineheight ' +
      '| link  | forecolor backcolor | table | help',
    setup: (editor) => {
      editor.ui.registry.addButton('linkbutton', {
        text: 'Add Button',
        icon: 'unselected',
        onAction: () => {
          editor.insertContent('&nbsp;<br><a style="background-color:#5caad2;color:white;margin:0 auto;' +
            'padding:10px;line-height:1rem;cursor:pointer;text-decoration:none; border-radius:7px"> Link </a>&nbsp;');
        }
      });
    },
  };

  ngOnInit(): void {
    this.footerForEmails = this.formGroupCampaign.get('emailFooter')
  }


  constructor(
  ) { }
}

